module.exports = function(x) {
  return (0.05859375 * x * x * (1 + 0.75 * x));
};